module.exports = __webpack_public_path__ + "static/media/video-thumbnail-1.4fa47680.png";